
import React from 'react';
import { cn } from '@/lib/utils';
import { LucideIcon } from 'lucide-react';

interface StatCardProps {
  title: string;
  value: string | number;
  icon: LucideIcon;
  description?: string;
  trend?: {
    value: number;
    isPositive: boolean;
  };
  className?: string;
  inlineTrend?: boolean;
}

const StatCard: React.FC<StatCardProps> = ({
  title,
  value,
  icon: Icon,
  description,
  trend,
  className,
  inlineTrend = false,
}) => {
  return (
    <div className={cn(
      "glass rounded-xl p-5 flex flex-col stat-card-responsive",
      className
    )}>
      <div className="flex justify-between items-start mb-2">
        <h3 className="text-sm font-medium text-muted-foreground overflow-hidden text-ellipsis">{title}</h3>
        <div className="p-2 rounded-full bg-secondary/50 flex-shrink-0">
          <Icon className="h-4 w-4 text-foreground" />
        </div>
      </div>
      
      <div className="flex flex-col justify-center flex-grow">
        <div className="text-3xl md:text-4xl font-bold mt-2 overflow-hidden text-ellipsis">{value}</div>
        
        {description && inlineTrend && trend && (
          <div className="flex items-center justify-between mt-1 flex-wrap">
            <p className="text-sm text-muted-foreground overflow-hidden text-ellipsis">{description}</p>
            <span
              className={cn(
                "text-xs font-medium flex items-center",
                trend.isPositive ? "text-green-500" : "text-red-500"
              )}
            >
              {trend.isPositive ? "+" : "-"}{Math.abs(trend.value)}% from last period
            </span>
          </div>
        )}
        
        {description && !inlineTrend && (
          <p className="text-sm text-muted-foreground mt-1 overflow-hidden text-ellipsis">{description}</p>
        )}
      </div>
      
      {trend && !inlineTrend && (
        <div className="flex items-center mt-2">
          <span
            className={cn(
              "text-xs font-medium flex items-center",
              trend.isPositive ? "text-green-500" : "text-red-500"
            )}
          >
            {trend.isPositive ? "+" : "-"}{Math.abs(trend.value)}%
          </span>
          <span className="text-xs text-muted-foreground ml-1">from last period</span>
        </div>
      )}
    </div>
  );
};

export default StatCard;
